<template>
 <div>
    <Header />
    <Top />
    <Schedule />
 </div>

</template>

<script>
  import Header from '../components/Header'
  import Top from '../components/Top' 
  import Schedule from '../views/Schedule'   

  export default {
    components: {
      Header, Top, Schedule
    }
  }
</script>
